<template>
	<slot name="root">
		<div :id="systemId">
			<slot />
		</div>
	</slot>

	<template v-for="(popup, index) in system.manualPopups" :key="index">
		<template v-if="popup.addTeleport">
			<teleport :to="systemId">
				<component :is="popup.component" v-model:is-open="popup.isOpen" v-bind="popup.props" />
			</teleport>
		</template>

		<template v-else>
			<component :is="popup.component" v-model:is-open="popup.isOpen" v-bind="popup.props" />
		</template>
	</template>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { PopupSystem } from '../src/PopupSystem';

export default defineComponent({
	props: {
		systemId: {
			type: String,
			required: true,
		},

		system: {
			type: PopupSystem,
			required: true,
		},
	},
});
</script>
